import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NotificationComponent} from '@modules/notification/components/notification/notification.component';
import {NotificationDto, SnackBarData} from '@modules/notification/models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private readonly snackBar: MatSnackBar) { }

  error(message: string, title: string = null, duration: number = 3000): void {
    this.showError(new NotificationDto(message, title, 'Close', duration));
  }

  warning(message: string, title: string = null): void {
    this.showAttention(new NotificationDto(message, title));
  }

  success(message: string, title: string = null): void {
    this.showSuccess(new NotificationDto(message, title, 'Close'));
  }

  protected showSuccess(data: NotificationDto): void {
    const snackBarData = new SnackBarData(data.message, data.title, 'done', data.action, data.duration);
    this.openSnackBar(snackBarData);
  }

  protected showAttention(data: NotificationDto): void {
    const snackBarData = new SnackBarData(data.message, data.title, 'warning', data.action, data.duration);
    this.openSnackBar(snackBarData);
  }

  protected showError(data: NotificationDto): void {
    const snackBarData = new SnackBarData(data.message, data.title, 'report', data.action, data.duration);
    this.openSnackBar(snackBarData);
  }

  private openSnackBar(snackBarData: SnackBarData): void {
    try {
      this.snackBar.openFromComponent(NotificationComponent, {
        announcementMessage: snackBarData.message,
        data: snackBarData,
        duration: snackBarData.duration,
      });
    } catch (error) {
    }
  }
}
